import { render, staticRenderFns } from "./InicioAdmin.vue?vue&type=template&id=4dcce78e&"
import script from "./InicioAdmin.vue?vue&type=script&lang=js&"
export * from "./InicioAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports